import { Grid } from "@material-ui/core";
import {
  InputTextMaster,
  InputOptionMaster,
  MasterButton,
} from "App/Component/ui";
import { TYPE_INSTANCE2 } from "App/constants";
import { useSelectOption } from "App/hooks";
import { isNull } from "App/utils/helpers";
import React from "react";
import { RESET_FILTER_TAB_BED, useInitialRuangAplicare } from "./helpers";

function FormFilterTabBed({ formFilter, setFormFilter, setNewData }) {
  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewData();
  };

  const kelasKamar = useSelectOption(
    true,
    "/bed/listkelaskamar",
    TYPE_INSTANCE2,
    "id",
    "name"
  );

  const kamar = useSelectOption(
    true,
    "/bed/listkamar",
    TYPE_INSTANCE2,
    "name",
    "name"
  );

  const ruangAplicare = useInitialRuangAplicare();

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={3}>
            <InputTextMaster
              name='id'
              label='ID'
              placeholder='ID'
              id='id'
              value={formFilter.id}
              onChange={handleChange("id")}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name='nama'
              label='NAMA'
              placeholder='Nama'
              id='nama'
              value={formFilter.nama}
              onChange={handleChange("nama")}
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name='kelas_kamar'
              label='KELAS KAMAR'
              withSearch={true}
              data={kelasKamar}
              value={formFilter.kelas_id}
              labelValue={formFilter.kelas_name}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    kelas_id: null,
                    kelas_name: "Pilih Kelas Kamar",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    kelas_id: e.value,
                    kelas_name: e.label,
                  });
                }
              }}
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name='kamar'
              label='KAMAR'
              withSearch={true}
              data={kamar}
              value={formFilter.kamar_name}
              labelValue={formFilter.kamar_name}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    kamar_name: "Pilih Kamar",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    kamar_name: e.value,
                  });
                }
              }}
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name='ruang_aplicares_name'
              label='RUANG APLICARE'
              withSearch={true}
              data={ruangAplicare}
              value={formFilter.ruang_aplicares_name}
              labelValue={formFilter.ruang_aplicares_name}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    ruang_aplicares_name: "Pilih Ruang Aplicare",
                    ruang_aplicares: null,
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    ruang_aplicares_name: e.label,
                    ruang_aplicares: e.value,
                  });
                }
              }}
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name='status'
              label='STATUS'
              id='status'
              withSearch={false}
              value={formFilter.status}
              onChange={handleChange("status")}
              data={[
                {
                  label: "Semua",
                  value: "",
                },
                {
                  label: "Aktif",
                  value: 1,
                },
                {
                  label: "Tidak Aktif",
                  value: 0,
                },
              ]}
            />
          </Grid>

          <Grid item sm={12}>
            <Grid container justifyContent='space-between'>
              <MasterButton
                outline={true}
                type={"button"}
                color='danger'
                className='mt-1'
                name='RESET'
                onClick={() => setFormFilter(RESET_FILTER_TAB_BED)}
                size='md'
              />
              <MasterButton
                outline={true}
                type={"submit"}
                color='green'
                className='mt-1'
                name='Cari'
                size='md'
              />
            </Grid>
          </Grid>
        </Grid>

        <div className='mt-2'>
          <hr style={{ margin: "1rem 0", opacity: "0.3" }} />
        </div>
      </form>
    </>
  );
}

export default FormFilterTabBed;
